import numberFormat from '@/utils/format/number.format';

const compact = numberFormat({ notation: 'compact', maximumFractionDigits: 1 });
const full = numberFormat({ maximumFractionDigits: 0 });
const percent = numberFormat({ maximumFractionDigits: 1, minimumFractionDigits: 0 });

export const formatCompact = (value: number): string => compact.format(value);

export const formatNumber = (value: number): string => full.format(value);

export const formatPercent = (value: number): string => `${percent.format(value)} %`;

export const formatDelta = (value: number): string => `${value > 0 ? '+' : ''}${percent.format(value)} %`;

export const formatMs = (value: number): string => (value >= 1000 ? `${percent.format(value / 1000)} s` : `${full.format(value)} ms`);
